module.exports = __webpack_public_path__ + "static/media/asi.2ebfd161.png";